import React from "react";
import {
    NATIVE_INVOICE_TERM_TYPES,
    NATIVE_INVOICE_TERM_TYPE_LABELS,
    isNativeInvoiceTermType,
} from "@common/helpers/invoice-terms.helper";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./InvoiceTermsFilter.module.scss";

const options: FilterMultiselectOption[] = NATIVE_INVOICE_TERM_TYPES.map(
    (termType) => ({
        value: termType,
        label: NATIVE_INVOICE_TERM_TYPE_LABELS[termType],
        searchableLabel: NATIVE_INVOICE_TERM_TYPE_LABELS[termType],
    }),
);

export const InvoiceTermsFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const selectedTermTypes = filters.termTypes ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                searchable={false}
                options={options}
                value={selectedTermTypes}
                onChange={(selectedValues) => {
                    const termTypes = selectedValues
                        .map((selectedValue) => String(selectedValue))
                        .filter(isNativeInvoiceTermType);
                    onChange({
                        termTypes: termTypes.length > 0 ? termTypes : undefined,
                    });
                }}
                name="termTypes"
                onBlur={noop}
            />
        </div>
    );
};
